interface IQUICK_SUMMARY_DATA {
  title: string;
  content: JSX.Element | string;
}

export const QUICK_SUMMARY_DATA: Record<string, IQUICK_SUMMARY_DATA> = {
  linkPanPreFill: {
    title: 'About Link PAN & Pre-fill',
    content: (
      <p>
        Link PAN and Prefill is a step which fetches your income details
        automatically hence saving your time and efforts to file Income tax
        through Cleartax.
      </p>
    ),
  },
  form16: {
    title: 'About Form-16',
    content: (
      <p>
        Form 16 is a document provided by an employer to an employee that
        contains details of the salary paid to the employee and the TDS (Tax
        Deducted at Source) deducted on that salary. <br />
        It is an important document for filing income tax returns as it provides
        information about the income earned and the taxes paid by the employee
        during the financial year.
      </p>
    ),
  },
  personalInfo: {
    title: 'About Personal Information',
    content: (
      <p>
        The Personal Information tab in ClearTax is used to enter essential
        details about yourself, such as identification, contact information,
        residential details, and bank details. <br />
        This information is crucial for accurately filing your income tax return
        and ensuring compliance with tax regulations.
      </p>
    ),
  },
  incomeSources: {
    title: 'About Income Sources',
    content: (
      <p>
        The Income Sources tab in ClearTax is used to add details about various
        sources of income, including salary, capital gains, business income,
        rental income, interest income, dividend income, and crypto income.{' '}
        <br />
        It helps in providing a complete picture of your income sources for
        accurate tax filing.
      </p>
    ),
  },
  taxSaving: {
    title: 'About Tax Savings',
    content: (
      <p>
        The Tax Savings tab in ClearTax is where you can add details about
        various tax-saving deductions, including popular deductions like
        investments in PPF, Life Insurance, ELSS, and more under Section 80C.{' '}
        <br />
        This section helps you optimize your tax savings by claiming eligible
        deductions and reducing your taxable income.
      </p>
    ),
  },
  taxSummaryDeclaration: {
    title: 'About Tax Summary & Declaration',
    content: (
      <p>
        The Tax Summary tab in ClearTax provides a comprehensive overview of all
        the information you have provided, including personal details, income
        sources, and tax-saving deductions. <br />
        It summarizes your financial data and recommends the income tax regime
        that saves you the most tax.
      </p>
    ),
  },
  eVerification: {
    title: 'About e-Verification',
    content: (
      <p>
        E-verification in ClearTax refers to the process of electronically
        verifying your income tax return after filing it online. This
        verification is done by generating an OTP (One-Time Password) that is
        sent to your registered mobile number or email address. By entering this
        OTP in ClearTax, you confirm the authenticity of your tax return filing.
      </p>
    ),
  },
  checkItrStatus: {
    title: 'About Check Status',
    content: (
      <p>
        You can check the ITR status after filing in ClearTax by logging in to
        the income tax e-filing portal. Then, click on &apos;e-File&apos;,
        choose &apos;Income Tax Returns&apos;, and select &apos;View Filed
        Returns&apos;. <br />
        From there, you can view the status of your filed returns, including the
        ITR status.
      </p>
    ),
  },
};
